import { BatchHttpLink } from 'apollo-link-batch-http'

const batchHttpLink = new BatchHttpLink({
  uri: '/.netlify/functions/graphql'
})

export default batchHttpLink
